module.exports = __webpack_public_path__ + "images/category_lp/watch/buy_fe395c69207afdee6e2cfc71e95e62df.png";